/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import { Helmet } from 'react-helmet';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import Cookies from 'universal-cookie';
import { Col, FormLabel, Row } from 'react-bootstrap';
import newsData from '../../data/news.json';
import blogsList from '../../data/blogs.json';
import ProductItem from '../Util/ProductItem/ProductItem';
import TheLayout from '../../layout/TheLayout';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import Features1 from '../../asset/Home/features1.png';
import Features2 from '../../asset/Home/features2.png';
import Features3 from '../../asset/Home/features3.png';
import Testshop from '../../asset/Home/testshop.png';
import Terracoat from '../../asset/Home/terracoat.png';
import Casestudy from './casestudy';
import SliderTop from './slider';
import ButtonComponent from '../Util/ButtonComponent';
import {
  getProductList,
} from '../../redux/actions/product';
import Interviews from '../Interviews/interviews';

const keywords = ['TERRA', 'ウイルス対策', '除菌剤', '港区', '赤坂', 'TERRA FORESTA', 'TERRA COAT', '光触媒コーディング （編集済み）'];
const cookies = new Cookies();

const HomePage = () => {
  const history = useHistory();
  const { search } = history.location;
  const paramsUrl = new URLSearchParams(search);
  const ruleGroupId = paramsUrl.get('rule_group_id');
  const salePersonId = paramsUrl.get('salesperson_id');
  const newsList = newsData.news;
  const productList = useSelector((state) => state.product.productList, shallowEqual);
  const dispatch = useDispatch();
  const productRankList = [];
  const productRankListView = [];
  const rankingList = [];
  productList.forEach((pr) => {
    if (pr?.memo.substr(0, 7) === 'ranking') {
      const mProduct = pr;
      const mRanking = pr.memo.substr(8, pr.memo.length - 8);
      mProduct.ranking = mRanking;
      rankingList.push(mRanking);
      productRankList.push(mProduct);
    }
  });
  rankingList.sort();
  rankingList.forEach((ranking) => {
    productRankList.forEach((p) => {
      if (p.ranking === ranking) {
        productRankListView.push(p);
      }
    });
  });
  useEffect(() => {
    if (ruleGroupId !== null) {
      cookies.set('rule_group_id', ruleGroupId, { path: '/' });
    }
  }, [ruleGroupId]);

  useEffect(() => {
    if (salePersonId !== null) {
      fetch(
        `${process.env.REACT_APP_ENDPOINT}/api/v2/salespersons/${salePersonId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          mode: 'cors',
        },
      )
        .then((response) => response.json())
        .then((payload) => {
          if (payload.company_id === 12) {
            cookies.set('salesperson_id', salePersonId, { path: '/' });
          } else {
            cookies.remove('salesperson_id');
          }
        }).catch(() => cookies.remove('salesperson_id'));
    }
  }, [salePersonId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(getProductList(Number(process.env.REACT_APP_COMPANY_ID), -1, 0));
  }, [dispatch]);
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>株式会社TERRA</title>
      </Helmet>
      <div className="home">
        <div className="first_view" style={{ height: 'auto', overflow: 'hidden', background: 'transperent' }}>
          <SliderTop />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9">
              <div className="p-2">
                <div className="ranking">
                  <p style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    Ranking&emsp;
                    <span
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      人気商品
                    </span>
                  </p>
                  <div className="product-list row">
                    {
                      productRankListView.map((item) => (
                        <ProductItem
                          key={item.id}
                          id={item.id}
                          imgUrl={item.main_image}
                          type={item.type}
                          name={item.name}
                          price={item.price}
                          page="top"
                          isSubscription={item.product_categories[0]?.category_name === '定期便'}
                          label
                        />
                      ))
                    }
                  </div>
                  <br />
                  <ButtonComponent
                    background="rgb(126,165,185)"
                    borderColor="rgb(126,165,185)"
                    color="white"
                    width="250px"
                    onClick={() => history.push('/product')}
                  >
                    商品一覧
                  </ButtonComponent>
                </div>
                <br />
                <br />

                <div className="product_features">
                  <p style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    Product features&emsp;
                    <MediaQuery query="(max-width: 320px)">
                      <br />
                    </MediaQuery>
                    <span
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      商品特長
                    </span>
                    <br />
                    <br />
                    <div className="row">
                      <div className="col-12 col-md-4">
                        <div className="row my-2">
                          <div className="col-6 col-sm-12" style={{ overflow: 'hidden' }}>
                            <img src={Features1} style={{ height: '100%' }} alt="テラフォレスタ ミスト" />
                          </div>
                          <div className="col-6 col-sm-12 my-3">
                            <h6>
                              早わかり！
                              <br />
                              「TERRA FORESTA」
                            </h6>
                            <h6>
                              TERRA FORESTA の魅力をご紹介します。
                            </h6>
                            <br />
                            <ButtonComponent
                              background="rgb(126,165,185)"
                              borderColor="rgb(126,165,185)"
                              color="white"
                              onClick={() => history.push('/features')}
                            >
                              詳しく見る
                            </ButtonComponent>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="row my-2">
                          <div className="col-6 col-sm-12" style={{ overflow: 'hidden' }}>
                            <img src={Features2} style={{ height: '100%' }} alt="テラフォレスタ ミスト" />
                          </div>
                          <div className="col-6 col-sm-12 my-3">
                            <h6>
                              独自の天然成分技術
                            </h6>
                            <h6>
                              天然成分にこだわった技術をご紹介します。
                            </h6>
                            <br />
                            <div style={{ position: 'relative', top: '20px' }}>
                              <ButtonComponent
                                background="rgb(126,165,185)"
                                borderColor="rgb(126,165,185)"
                                color="white"
                                onClick={() => history.push('/features')}
                              >
                                詳しく見る
                              </ButtonComponent>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="row my-2">
                          <div className="col-6 col-sm-12" style={{ overflow: 'hidden' }}>
                            <img src={Features3} style={{ height: '100%' }} alt="テラフォレスタ ミスト" />
                          </div>
                          <div className="col-6 col-sm-12 my-3">
                            <h6>
                              除菌・消臭に優れた効果
                            </h6>
                            <h6>
                              アレルギー、タバコの消臭な
                              どでお困りの方に安全な清潔
                              空間をお届けします。
                            </h6>
                            <br />
                            <ButtonComponent
                              background="rgb(126,165,185)"
                              borderColor="rgb(126,165,185)"
                              color="white"
                              onClick={() => history.push('/features')}
                            >
                              詳しく見る
                            </ButtonComponent>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p>
                  <br />
                  <br />
                  <div className="row">
                    <div className="col-12 col-md-6 my-2">
                      <Link to="/testshop">
                        <img src={Testshop} style={{ width: '100%' }} alt="テラフォレスタ ミスト" />
                      </Link>
                    </div>
                    <div className="col-12 col-md-6 my-2">
                      <a href="http://www.terra-coat.jp" target="_blank" rel="noreferrer">
                        <img src={Terracoat} style={{ width: '100%' }} alt="terra-coat" />
                      </a>
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <div className="case_study">
                  <p style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    Case study&emsp;
                    <span
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      導入事例
                    </span>
                    <br />
                    <br />
                    <div className="row">
                      <div className="col-12">
                        <Casestudy />
                      </div>
                    </div>
                  </p>
                </div>
                <br />
                <br />
                <div className="interviews">
                  <p style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    Customer&apos;s voice&emsp;
                    <MediaQuery query="(max-width: 340px)">
                      <br />
                    </MediaQuery>
                    <span
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      お客様の声
                    </span>
                  </p>
                </div>
                <br />
                <Interviews />
                <br />
                <br />
                <div className="product_features">
                  <p style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    Contents&emsp;
                    <span
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      コンテンツ
                    </span>
                    <br />
                    <br />
                    <Row md={3} xs={1} noGutters className="content-image-box align-items-start">
                      {
                blogsList.blog?.map((item) => (
                  <a key={item.url} href={item.url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'rgba(44, 81, 115)' }}>
                    <Col noGutters>
                      <span className="img-content-home" dangerouslySetInnerHTML={{ __html: item.image }} />
                      <FormLabel>{item.title}</FormLabel>
                    </Col>
                  </a>
                ))
              }
                    </Row>
                  </p>
                  <br />
                  <br />
                </div>
                <br />
                <br />
                <div className="news">
                  <p style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    News&emsp;
                    <span
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      お知らせ
                    </span>
                    <br />
                  </p>
                  {
                    newsList.filter((news, index) => index < 5)
                      .map((news) => {
                        let color = '#595f97';
                        if (news?.tag === 'お知らせ') {
                          color = 'rgb(0,70,168)';
                        } else if (news?.tag === 'キャンペーン') {
                          color = '#2eb0a6';
                        } else {
                          color = '#595f97';
                        }
                        return (
                          <Link key={`${news.id}`} to={`/news/${news.id}`} style={{ textDecoration: 'none', color: 'rgba(44, 81, 115)' }}>
                            <div
                              className="row py-3 no-gutters"
                              style={{
                                borderBottom: news.id > 1 ? '1px solid rgba(44, 81, 115)' : '',
                              }}
                            >
                              <div className="col-12 col-md-4">
                                <span style={{ color: 'black', marginRight: '30px' }}>{news.date}</span>
                                <span
                                  style={{
                                    fontSize: '90%',
                                    color: 'white',
                                    padding: '2px 10px',
                                    width: '120px',
                                    display: 'inline-block',
                                    textAlign: 'center',
                                    backgroundColor: `${color}`,
                                  }}
                                >
                                  {news.tag}
                                </span>
                              </div>
                              <div className="col-12 col-md-8" dangerouslySetInnerHTML={{ __html: news.title }} />
                            </div>
                          </Link>
                        );
                      })
                  }
                  <br />
                  <ButtonComponent
                    background="rgb(126,165,185)"
                    borderColor="rgb(126,165,185)"
                    color="white"
                    width="280px"
                    onClick={() => history.push('/news')}
                  >
                    お知らせ一覧
                  </ButtonComponent>
                </div>
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};

export default HomePage;
